import eCommerce from '../images/e-commerce.jpg'
import HIV from '../images/HIV-Healthcare.png'
import tableau from '../images/Tableau.png'
import LFQA from '../images/LFQA.png'
import restaurant from '../images/restaurant-recommendation.png'
import perfume from '../images/perfume.png'
import reddit from '../images/Reddit-analysis.jpg'

const ProjectsInfo = [
  {
    img: [eCommerce],
    name: 'E-commerce Analysis - Big Data Driven Machine Learning Project',
    url: 'https://qinren.georgetown.domains/Taobao-Analysis/',
    keyword: 'Pyspark, SQL, Logistic Regression, XGBoost, Random Forest, CTR',
  },
  {
    img: [HIV],
    name: 'HIV Healthcare Global Supply Chain Prediction Analysis - Python Analysis Project',
    url: 'https://github.com/QinrenZhou/Supply-Chain-Machine-Learning-Analysis',
    keyword: 'Supply Chain, API, Bagging, PCA, Machine Learning',
  },
  {
    img: [tableau],
    name: 'Tableau Dashboard Value Inc. Sales Analysis',
    url: 'https://public.tableau.com/app/profile/qinren.zhou/viz/ValueInc_SalesAnalysis_16583507193650/Dashboard1',
    keyword: 'Tableau, BI visualization',
  },
  {
    img: [LFQA],
    name: 'A Constrained Long-form Question Answering (LFQA) Model on eli5_category',
    url: 'https://celeritasml.netlify.app/posts/2021-12-01-eli5c/',
    keyword: 'Key words: NLP, Bert, Bart',
  },
  {
    img: [restaurant],
    name: 'A Restaurant Recommendation Algorithm Solution',
    url: 'https://github.com/QinrenZhou/Restaurant-Recommendation-Algorithm-Solution',
    desc: '',
    keyword: 'Python, Decision Tree, Text Analysis',
  },
  {
    img: [perfume],
    name: 'About Perfume - Data Analysis Project',
    url: 'http://qinren.georgetown.domains/About%20Me.html',
    keyword: 'Python, Market Analysis, Customer Analysis, Machine Learning',
  },
  {
    img: [reddit],
    name: 'Reddit Analysis-AWS Big Data Project',
    url: 'https://qinren.georgetown.domains/Reddit-Analysis/',
    keyword: 'AWS, Cloud Computing, Pyspark, NLP',
  },
]

export const ProjectData = {
  projectsInfo: ProjectsInfo,
}
